import type {
	OffMarketUnitEntity,
	OnMarketUnitEntity
} from "#backend/modules/buildium-listings/buildium-listings.schemas.js";
import {
	COMMERCIAL_LEASING_EMAIL,
	RESIDENTIAL_LEASING_EMAIL
} from "#lib/constants/leasing-contacts.js";

export function resolveNotificationEmail(
	unit: OnMarketUnitEntity | OffMarketUnitEntity | undefined
): string {
	if (unit?.property?.rentalType === "Commercial") return COMMERCIAL_LEASING_EMAIL;
	return unit?.property?.rentalManager?.email ?? RESIDENTIAL_LEASING_EMAIL;
}
